import React from 'react';

export const pageMeta = {
  "name": "JS Class Inheritance",
  "link": "/javascript/classes/inheritance"
};

export default function JavascriptClassesInheritance() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Class Inheritance</h2>
      <p>Route: /javascript/classes/inheritance</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
